import { all, call, cancel, delay, fork, put, select, take, takeLatest } from "redux-saga/effects";
import { webToMobile } from "../../api/apiClient";
import { configureKYCTransactionAPIClient } from "../../api/axiosConfig";
import { log } from "../../utils/loggger";
import { RECEIVE_APPCONFIG_SUCCESS, updateProspect, updateProspectId } from "../actions/appConfig";
import { KycTransactionSuccess } from "../actions/kyc";
import {
  setSessionData,
  START_SCHEDULER,
  STOP_SCHEDULER,
  SYNC_SESSION,
  wtmSessionError
} from "../actions/webToMobile";
import { getAuthorizationHeader, getProspectId } from "../selectors/appConfig";
import { getwtmSessionDetails } from "../selectors/webToMobile";

function* SyncSession({ payload }) {
  try {
    //waiting for app config be loaded before invoking the authentication
    yield take(RECEIVE_APPCONFIG_SUCCESS);
    const headers = { headers: { Authorization: `Bearer ${payload}` } };

    const response = yield call(webToMobile.wtmSyncSession, { tempToken: payload }, headers);
    const {
      data: {
        kycTransaction,
        prospectId,
        fullname,
        isIslamicBanking,
        companyCategory,
        licenseOrCOINumber,
        licenseOrCOIExpiryDate,
        dateOfIncorporation,
        licenseIssuingAuthority,
        accountType
      },
      webMobileRefId,
      SID,
      status,
      type
    } = response.data;
    const kycTransactionData = {
      transactionId: kycTransaction.id,
      kycUserToken: kycTransaction.userToken
    };
    configureKYCTransactionAPIClient(kycTransaction.id, kycTransaction.userToken);

    const sessionDetails = {
      sessionType: type,
      webMobileRefId,
      status,
      SID,
      prospectId
    };
    yield put(
      updateProspect({
        "prospect.applicantInfo.fullName": fullname,
        "prospect.applicationInfo.islamicBanking": JSON.parse(isIslamicBanking),
        "prospect.organizationInfo.companyCategory": companyCategory,
        "prospect.organizationInfo.licenseOrCOINumber": licenseOrCOINumber,
        "prospect.organizationInfo.licenseOrCOIExpiryDate": licenseOrCOIExpiryDate,
        "prospect.organizationInfo.dateOfIncorporation": dateOfIncorporation,
        "prospect.organizationInfo.licenseIssuingAuthority": licenseIssuingAuthority,
        "prospect.applicationInfo.accountType": accountType
      })
    );
    yield put(updateProspectId(prospectId));
    yield put(setSessionData(sessionDetails));
    yield put(KycTransactionSuccess(kycTransactionData));
  } catch (error) {
    log(error);
  }
}

function* schedulerWorker({ payload, type }) {
  while (true) {
    yield call(updateStatus, payload);
    if (type === STOP_SCHEDULER) {
      break;
    }
    yield delay(process.env.REACT_APP_WTM_SCHEDULER_INTERVAL || 5000);
  }
}

function* setWTMError(error) {
  yield put(wtmSessionError(error));
}

function* updateStatus(payload) {
  try {
    const prospectId = yield select(getProspectId);
    const headers = yield select(getAuthorizationHeader);
    const {
      sessionData: { webMobileRefId }
    } = yield select(getwtmSessionDetails);
    yield call(
      webToMobile.wtmStatusUpdate,
      { status: payload },
      headers,
      prospectId,
      webMobileRefId
    );
  } catch (error) {
    const { status } = error.response;
    if (status === 400 || status === 412 || status === 401) {
      yield call(setWTMError, error.message);
      const bgSyncSession = yield fork(schedulerWorker);
      yield cancel(bgSyncSession);
    }

    log(error);
  }
}

export default function* webToMobileSaga() {
  yield all([
    takeLatest(SYNC_SESSION, SyncSession),
    takeLatest(START_SCHEDULER, schedulerWorker),
    takeLatest(STOP_SCHEDULER, schedulerWorker)
  ]);
}
